import { i18n } from '@/locales/index';
// import { coins } from 'assets/images-new/icon/coins-w.webp';
/**
 * 数字商品 列表排序
 * price_asc 最低价格升序
 * price_desc 最低价格降序
 * in_stock 优先展示有货的
 * out_of_stock 优先展示无货的
 */
export const giftListSort = computed(() => {
  return [
    {
      label: i18n.global.t('filter.Defaultsort'),
      value: 'default'
    },
    {
      label: i18n.global.t('filter.Pricehighestfirst'),
      value: 'price_desc'
    },
    {
      label: i18n.global.t('filter.Pricelowestfirst'),
      value: 'price_asc'
    },
    {
      label: i18n.global.t('filter.Releasedateoldest'),
      value: 'shelf_time_asc'
    },
    {
      label: i18n.global.t('filter.Releasedatenewest'),
      value: 'shelf_time_desc'
    }
  ];
});

/**
 * spu卡片列表排序
 * 1: 由低到高
 * 2：由高到底
 */
export const spuCardListSort = computed(() => {
  return [
    {
      label: i18n.global.t('filter.PriceLowtoHigh'),
      value: 1
    },
    {
      label: i18n.global.t('filter.PriceHightoLow'),
      value: 2
    }
  ];
});

export const sortList = computed(() => {
  return [
    {
      valueName: i18n.global.t('filter.PriceLowtoHigh'),
      valueId: 1
    },
    {
      valueName: i18n.global.t('filter.PriceHightoLow'),
      valueId: 2
    }
  ];
});
/*
 * 账号/装备/金币/代练按照 spu 维度计算，直充按照 sku 维度计算
 * 1、账号/装备/代练 offer 列表页
 * 2、直充/金币 offer 详情页
 */
export const spuSortList = computed(() => {
  return [
    {
      valueName: 'Fastest Delivery',
      valueId: 1
    },
    {
      valueName: 'Top Selling',
      valueId: 2
    },
    {
      valueName: 'Cheapest Price',
      valueId: 3
    },
    {
      valueName: 'Recent Sales',
      valueId: 4
    },
    {
      valueName: 'Highest Price',
      valueId: 5
    }
  ];
});
/**
 * 数字商品 详情排序
 * 不传默认从低到高
 * 1 从低到高
 * 2 从高到底
 */
export const giftDetailSort = computed(() => {
  return [
    {
      label: i18n.global.t('filter.Pricehighestfirst'),
      value: '1'
    },
    {
      label: i18n.global.t('filter.Pricelowestfirst'),
      value: '2'
    }
  ];
});
// gameService 业务id
export const gameService = {
  coins: '1820693954263351300', // 金币
  items: '1820693954263351301', // 装备
  accounts: '1820693954263351302', // 账号
  coaching: '1820693954263351303', // 陪玩
  boosting: '1820693954263351304', // 代练
  topUp: '1820693954263351305', // 直充
  all: [
    '1820693954263351300',
    '1820693954263351301',
    '1820693954263351302',
    '1820693954263351303',
    '1820693954263351304',
    '1820693954263351305'
  ]
};

// 数字商品 业务id
export const digitalGood = {
  gamePoints: '1820693954263351306', // 游戏点卡
  giftCards: '1820693954263351307', // 礼品卡
  subscriptions: '1820693954263351308', // 订阅
  software: '1820693954263351309', // 软件
  games: '1820693954263351310', // 主机游戏 （原 video games）
  all: ['1820693954263351306', '1820693954263351307', '1820693954263351308', '1820693954263351309', '1820693954263351310']
};

// fifa 业务id
export const fifa = {
  coins: '1848553943624232961', // fifa金币
  player: '1848554129733890049', // fifa球员
  squad: '1876446768564609026', // fifa squad
  sbc: '1848554356402466818', // fifa sbc
  ultimateTeam: '1848554567304654850', // fifa 球队
  all: ['1848553943624232961', '1848554129733890049', '1876446768564609026', '1848554356402466818', ' 1848554567304654850']
};
// 第三方 按钮
export const thirdParty = [
  {
    label: 'google',
    value: 0
  },
  {
    label: 'discord',
    value: 6
  },
  {
    label: 'facebook',
    value: 1
  },
  {
    label: 'steam',
    value: 5
  },

  {
    label: 'twitter',
    value: 2
  },
  {
    label: 'paypal',
    value: 3
  }
];

// source映射规则
export const shareSourceMap = [
  {
    channel: 'FIFA谷歌广告',
    code: 'code'
  },
  {
    channel: 'C2C谷歌广告',
    code: 'linkpath'
  },
  {
    channel: '合作网红',
    code: 'source'
  },
  {
    channel: 'affiliate 推广',
    code: 'referral-code'
  },
  {
    channel: '社媒',
    code: 'utm_source'
  },
  {
    channel: '分享',
    code: 'share'
  }
];
